import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "border-System/app_border rounded-sm border-[1px] border-solid h-full flex flex-col justify-between" }
const _hoisted_3 = { class: "px-[32px] pt-[32px]" }
const _hoisted_4 = {
  "data-testid": "change-password--title",
  class: "text-Text/text_high gordita-medium-500-16 pb-6"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1)

import { IncrediField, IncrediButton, IncrediForm, useIncrediForm } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { useUser_UpdatePasswordMutation } from '@/graphql/codegen/generated/graphql';
import { useI18n } from 'vue-i18n';
import { useNotify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { validatePassword } from '@/utils/string-validations';


export default /*#__PURE__*/_defineComponent({
  __name: 'changePasswordTab',
  setup(__props) {

const { t } = useI18n();
const { toastMessage } = useNotify();

const getPasswordValidationMessage = (value: string, isNewPassword: boolean | undefined = undefined) => {
  if (!value) return t('userProfile.changePasswordTab.validationMessages.requiredField'); // if field is empty
  if (isNewPassword && !validatePassword(value)) return t('userProfile.changePasswordTab.validationMessages.newPassword'); // For new password
  if (!isNewPassword) return t('userProfile.changePasswordTab.validationMessages.confirmPassword'); // For confirm password field
  return '';
};

const { form, fields } = useIncrediForm({
  initialValues: {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  },
  validationSchema: {
    currentPassword: (val: any) => !!val || getPasswordValidationMessage(val),
    newPassword: (val: any) => (!!val && validatePassword(val)) || getPasswordValidationMessage(val, true),
    confirmNewPassword: (val: any) => (!!val && fields.newPassword.value.value === val) || getPasswordValidationMessage(val, false),
  },
});

const GQL_updatePassword = useUser_UpdatePasswordMutation({});

const saveChangePassword = form.handleSubmit(async () => {
  try {
    const result = await GQL_updatePassword.mutate({
      data: {
        oldPassword: fields.currentPassword.value.value,
        newPassword: fields.newPassword.value.value,
      },
    });
    if (result?.data?.user_updatePassword) {
      toastMessage(t('userProfile.changePasswordTab.successToastText', CONST_NOTIFY.MESSAGE_TYPE.SUCCESS));
      form.resetForm();
    }
  } catch (error) {
    toastMessage(t('userProfile.failureToastText'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    form.resetForm();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "h-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IncrediForm), {
          class: "h-full",
          onSubmit: _unref(saveChangePassword),
          onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('userProfile.changePasswordTab.title')), 1),
                _createVNode(_unref(IncrediField), {
                  modelValue: _unref(fields).currentPassword.value.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(fields).currentPassword.value.value) = $event)),
                  "data-testid": "change-password--current-password-input",
                  error: !!_unref(form).errors.value.currentPassword,
                  "error-message": _unref(form).errors.value.currentPassword,
                  class: "input-field",
                  size: "big",
                  label: "Current Password",
                  "field-type": "password",
                  onChange: _cache[1] || (_cache[1] = () => _unref(fields).currentPassword.validate())
                }, null, 8, ["modelValue", "error", "error-message"]),
                _createVNode(_unref(IncrediField), {
                  modelValue: _unref(fields).newPassword.value.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(fields).newPassword.value.value) = $event)),
                  "data-testid": "change-password--new-password-input",
                  error: !!_unref(form).errors.value.newPassword,
                  "error-message": _unref(form).errors.value.newPassword,
                  class: "input-field mt-10",
                  name: "new-password-input",
                  size: "big",
                  label: "New Password",
                  "field-type": "password",
                  onChange: _cache[3] || (_cache[3] = () => _unref(fields).newPassword.validate())
                }, null, 8, ["modelValue", "error", "error-message"]),
                _createVNode(_unref(IncrediField), {
                  modelValue: _unref(fields).confirmNewPassword.value.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(fields).confirmNewPassword.value.value) = $event)),
                  "data-testid": "change-password--confirm-new-password-input",
                  error: !!_unref(form).errors.value.confirmNewPassword,
                  "error-message": _unref(form).errors.value.confirmNewPassword,
                  class: "input-field mt-10",
                  name: "confirm-new-password-input",
                  size: "big",
                  label: "Confirm New Password",
                  "field-type": "password",
                  onChange: _cache[5] || (_cache[5] = () => _unref(fields).confirmNewPassword.validate())
                }, null, 8, ["modelValue", "error", "error-message"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_unref(IncrediButton), {
                  "data-testid": "change-password--save-button",
                  class: "flex flex-row justify-end items-end px-[24px] py-[10px] mb-0",
                  design: "primary-green",
                  size: "big",
                  disabled: !_unref(form).meta.value.dirty,
                  type: "submit",
                  onKeydown: _withKeys(_withModifiers(_unref(saveChangePassword), ["prevent"]), ["enter"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('userProfile.saveBtn')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onKeydown"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _: 1
  }))
}
}

})